import React from "react";
import styled from "styled-components";

interface DidYouKnowInlineProps {
  headline?: string;
  body: string;
  imageSrc?: string;
  imageAlt?: string;
  reverse?: boolean;
}

const DidYouKnowInline: React.FC<DidYouKnowInlineProps> = ({
  headline = "Did you know?",
  body,
  imageSrc = "/didyouknow.png",
  imageAlt = "Did you know illustration",
  reverse = false,
}) => {
  return (
    <Wrapper aria-label="Did you know inline">
      <Row reverse={reverse}>
        {imageSrc && (
          <ThumbCol>
            <ThumbWrapper>
              <img src={imageSrc} alt={imageAlt} className="radius6" />
            </ThumbWrapper>
          </ThumbCol>
        )}
        <TextCol>
          <h4 className="font13 semiBold">{headline}</h4>
          <p className="font18 extraBold">{body}</p>
        </TextCol>
      </Row>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 8px 0;
`;

const Row = styled.div<{ reverse?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-direction: ${(props: { reverse?: boolean }) =>
    props.reverse ? "row-reverse" : "row"};

  @media (max-width: 960px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const ThumbCol = styled.div`
  flex: 0 0 auto;
`;

const ThumbWrapper = styled.div`
  width: 170px;
  height: 170px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

const TextCol = styled.div`
  flex: 1 1 auto;
  p {
    margin-top: 4px;
    line-height: 1.4rem;
  }
`;

export default DidYouKnowInline;

